export default "__VITE_ASSET__DkmMBQ$m__"